import { render, staticRenderFns } from "./teacherPart.vue?vue&type=template&id=e88380ba&scoped=true"
import script from "./teacherPart.vue?vue&type=script&lang=js"
export * from "./teacherPart.vue?vue&type=script&lang=js"
import style0 from "./teacherPart.vue?vue&type=style&index=0&id=e88380ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88380ba",
  null
  
)

export default component.exports